import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {ValidationPageContainer} from '../ValidationProcess/style';

interface ValidationProcessProps {
  color?: string;
  style?: React.CSSProperties
  success?: boolean;
  callbackUrl?: string;
  username?: string | null;
  operationId?: string;
  operationGuid?: string;
  business?: string;
  platform?: string;
  retry?: string;
}

const ValidationProcessCompleted = ({
                                      color = "#666",
                                      style,
                                      success,
                                      callbackUrl,
                                      username,
                                      operationId,
                                      operationGuid,
                                      business,
                                      platform,
                                      retry
                                    }: ValidationProcessProps) => {
  const {t} = useTranslation();

  const handleManualContinuation = () => {
    if (username) {
      if (retry) {
        window.location.assign(`https://cuenta-qa.primmavalores.com/onboarding-failed?email=${encodeURIComponent(username)}&platform=${platform}&retry=${retry}`);
      }
      if(retry == "1"){
        window
          .location
          .assign(`https://cuenta-qa.primmavalores.com/onboarding-failed?email=${encodeURIComponent(username)}&platform=${platform}&retry=${retry}`);
      }
      if(retry == "true"){
        window
          .location
          .assign(`https://cuenta-qa.primmavalores.com/onboarding-failed?email=${encodeURIComponent(username)}&platform=${platform}&retry=${retry}`);
      }
      window.location.assign(`https://cuenta-qa.primmavalores.com/onboarding-failed?email=${encodeURIComponent(username)}&platform=${platform}`);
    }
  };

  function RedirectToCallbackUrl() {
    useEffect(() => {
      const timeout = setTimeout(() => {
        console.log(platform, "platform");
        if (callbackUrl) {
          if (callbackUrl?.indexOf("{{username}}") && username)
            callbackUrl = callbackUrl?.replace("{{username}}", username);
          if (callbackUrl?.indexOf("{{operationId}}") && operationId)
            callbackUrl = callbackUrl?.replace("{{operationId}}", operationId);
          if (callbackUrl?.indexOf("{{operationGuid}}") && operationGuid)
            callbackUrl = callbackUrl?.replace("{{operationGuid}}", operationGuid);
          if(platform){
            callbackUrl = callbackUrl + `&platform=${platform}`;
          }
          if(retry){
            callbackUrl = callbackUrl + `&retry=${retry}`;
          }
          if(retry == "1"){
            callbackUrl = callbackUrl + `&retry=${retry}`;
          }
          if(retry == "true"){
            callbackUrl = callbackUrl + `&retry=${retry}`;
          }

          console.log("redirects to " + callbackUrl);
          window.location.assign(callbackUrl);
        }
      }, 3000);

      return () => clearTimeout(timeout);
    }, []);

    return <>Will redirect in 3 seconds...</>;
  }

  return (
    <ValidationPageContainer color={color} data-testid="validationprocesscompleted" style={{...style}}>
      {success ? (
        <>
          <div className="verificationSuccess">
            <img src={'/assets/img/emoji-success.svg'} alt=""/>
            <h3>{t('verifications.complete.success.title')}</h3>
            <p><strong>{t('verifications.complete.success.description')}</strong></p>
            <p><strong>{t('verifications.complete.success.disclaimer')}</strong></p>
          </div>
          {callbackUrl ? (<RedirectToCallbackUrl/>) : null}
        </>
      ) : (
        <div className="verificationFail">
          <h3>Ha ocurrido un error</h3>          
          <p><strong>Lo sentimos, no pudimos validar tu identidad en este momento. Sin embargo puedes continuar con tu solicitud y más adelante te pediremos que vuelvas a intentar.</strong></p>      
          {business === "Primma" && (
            <button onClick={handleManualContinuation}>Continuar registro de igual forma</button>
          )}
        </div>
      )
      }
    </ValidationPageContainer>
  );
};

export default ValidationProcessCompleted;
